const getPrices = (orderLineItem)=>{
    var ref;
    var _gross;
    const price = (_gross = orderLineItem.price.total.gross) !== null && _gross !== void 0 ? _gross : 0;
    var _subtotal;
    const originalPrice = (_subtotal = orderLineItem.price.total.subtotal) !== null && _subtotal !== void 0 ? _subtotal : 0;
    var _amount;
    const discountPrice = (_amount = orderLineItem.price.total.discount.amount) !== null && _amount !== void 0 ? _amount : 0;
    var _amount1;
    const tax = (_amount1 = (ref = orderLineItem.price) === null || ref === void 0 ? void 0 : ref.total.tax.amount) !== null && _amount1 !== void 0 ? _amount1 : 0;
    return {
        price,
        discountPrice,
        tax,
        originalPrice
    };
};

export { getPrices };
//# sourceMappingURL=get-prices.js.map
